(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6000],{

/***/ 38819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seo-pricing-uk",
      function () {
        return __webpack_require__(28323);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ seo_pricing_uk; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/animation.ts
var animation = __webpack_require__(89428);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var NextLink = __webpack_require__(99472);
// EXTERNAL MODULE: ./src/components/blocks/hero/index.ts + 40 modules
var hero = __webpack_require__(53901);
// EXTERNAL MODULE: ./src/components/reuseable/ContactFooterCombo.tsx
var ContactFooterCombo = __webpack_require__(79266);
;// CONCATENATED MODULE: ./src/data/answer-the-public/seo-pricing.js
var seopricing = [
    {
        title: "how much does seo cost",
        url: ""
    },
    {
        title: "how much does seo cost for small business uk",
        url: ""
    },
    {
        title: "how much does seo cost uk",
        url: ""
    },
    {
        title: "how much is seo per month uk",
        url: ""
    },
    {
        title: "how much is seo uk",
        url: ""
    },
    {
        title: "how to price seo",
        url: ""
    },
    {
        title: "seo cost per month uk",
        url: ""
    },
    {
        title: "seo pricing in uk",
        url: ""
    },
    {
        title: "seo pricing uk",
        url: ""
    },
    {
        title: "why is seo important for business",
        url: ""
    },
    {
        title: "why use seo",
        url: ""
    }, 
];

// EXTERNAL MODULE: ./src/components/blocks/video/Video.tsx
var Video = __webpack_require__(62920);
// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(74870);
;// CONCATENATED MODULE: ./pages/seo-pricing-uk/index.tsx




// -------- custom component -------- //






var answerThePublic = seopricing;
var details = {
    pageName: "Molto SEO pricing",
    categories: "seo, web design",
    description: "Molto SEO pricing for the <hi></hi>ghest quality conversion rate optimisation services",
    parentDirectories: ""
};
var croPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "".concat(keywords.SEOPricing[0].title),
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(keywords.SEOPricing[0].url, "/").concat(keywords.SEOPricing[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "content-wrapper bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: (0,animation/* fadeInAnimate */.St)("900ms"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video["default"], {
                                    heading: "Seo Pricing",
                                    title1: "SEO",
                                    title2: "AUDIT",
                                    title3: "",
                                    movie: "/1.mp4",
                                    placeholder: "1-bg.jpg",
                                    button: "website-test",
                                    fontsize1: 150,
                                    fontsize2: 150,
                                    body: "",
                                    intro: " helps London companies greatly improve Google ranking with affordably priced SEO packages. If\xa0you\xa0want to accelerate your business online, we are the experts using proprietary technology and AI."
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-light",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container py-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-6 mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.SEOPricing[0].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        keywords.SEOPricing[0].title,
                                                        " is an important consideration for businesses looking to invest in search engine optimization services. At Molto SEO, we understand the significance of transparent and competitive pricing when it comes to delivering exceptional value to our clients. As a leading technical SEO agency, we strive to make ",
                                                        keywords.SEOPricing[0].title,
                                                        " accessible and affordable for businesses of all sizes."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "The pricing structure for SEO services in the UK can vary based on several factors. The scope of work required, the level of competition in your industry, and the specific goals you aim to achieve through SEO all play a role in determining the cost. At Molto SEO, your",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.HomeList[0].title,
                                                            href: "/"
                                                        }),
                                                        ", we take a personalized approach to SEO pricing in the UK. Our team works closely with you to understand your business objectives, budget constraints, and desired outcomes. This allows us to create a tailored SEO strategy that maximizes your return on investment."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Our flexible pricing options ensure that you can choose a package that suits your needs and budget. Whether you're a small business with limited resources or a larger enterprise with more extensive requirements, we have SEO pricing options that fit your specific circumstances. We believe in transparency, and our team will provide a detailed breakdown of the services included in each package, allowing you to make an informed decision."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "By investing in SEO with Molto SEO, you can expect not only competitive pricing but also exceptional results. Our experienced team of SEO professionals will work diligently to improve your website's visibility, drive organic traffic, and boost your online presence. We are committed to delivering tangible outcomes and helping your business thrive in the competitive online landscape."
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "website-test"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* Hero1 */.lE, {
                                bgcolor: "bg-soft-primary mb-20 mt-20",
                                title: "",
                                lead: "",
                                body: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center",
                                        id: "report",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center fs-34 mb-0 mx-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "GET YOUR FREE ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-fuchsia",
                                                            children: "TECHNICAL SEO REPORT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-center fs-18 mx-auto",
                                                children: [
                                                    "Action the findings from the report or purchase ",
                                                    keywords.HomeList[8].title
                                                ]
                                            })
                                        ]
                                    }, 100)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-light",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container py-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-6 mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.SEOPricing[1].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        keywords.SEOPricing[1].title,
                                                        " can be a significant consideration for businesses looking to enhance their online presence. At Molto SEO, we understand the importance of offering affordable SEO packages that provide optimal results within your budget. We believe in transparency when it comes to",
                                                        " ",
                                                        keywords.SEOPricing[1].title,
                                                        ", ensuring that you have a clear understanding of the investment required for our services."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Our pricing structure is designed to be transparent, with no hidden fees or surprises. We provide detailed breakdowns of the services included in each package, allowing you to make an informed decision based on your specific needs and goals. By knowing exactly what you're paying for, you can allocate your resources effectively and make the most of your SEO investment."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "While upfront ",
                                                        keywords.SEOPricing[1].title,
                                                        " may vary depending on factors such as the scope of work and the competitiveness of your industry, it's important to consider the long-term benefits and the impact on your business's growth. Investing in SEO can yield significant returns over time. Improved organic rankings, increased website visibility, and targeted traffic can lead to higher conversions and revenue generation."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "At Molto SEO, we understand that every business is unique, and we tailor our SEO packages to meet your specific requirements and budget. We work closely with you to develop a comprehensive SEO strategy that aligns with your goals and ensures that you get the most value for your investment. Our experienced team of SEO professionals will implement proven techniques and best practices to improve your website's performance and drive sustainable growth."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "By investing in SEO with Molto SEO, you're not only investing in the present but also in the future success of your business. Our goal is to help you achieve long-term results and maximize the return on your SEO investment. We believe that SEO costs in the UK should be an investment rather than an expense, as the benefits can extend far beyond the initial upfront costs."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.SEOPricing[3].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "At Molto SEO, your",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.EcommerceSEO[1].title,
                                                            href: "/" + keywords.EcommerceSEO[0].url + "/" + keywords.EcommerceSEO[0].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        ", we know ",
                                                        keywords.SEOPricing[2].title,
                                                        " and we strive to deliver exceptional value for your investment. Our team of experienced professionals works diligently to optimize your website, propose you a tailored",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.SEOAudit[1].title,
                                                            href: "/" + keywords.SEOAudit[0].url + "/" + keywords.SEOAudit[0].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        " ",
                                                        "with the best",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.CRO[2].title,
                                                            href: "/" + keywords.CRO[2].url + "/" + keywords.CRO[0].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        ", and drive sustainable growth. We provide regular reporting and transparent communication, keeping you informed about the progress and impact of our SEO efforts. Ready to unlock the potential of SEO within your budget? Choose Molto SEO for transparent ",
                                                        keywords.SEOPricing[1].title,
                                                        ". Contact us today to discuss your business goals and find an SEO package that suits your needs. Together, we can elevate your online presence and achieve lasting success in the competitive digital landscape."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    children: [
                                                        answerThePublic[10].title,
                                                        "?"
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "In today's digital age, having a strong online presence is crucial for businesses of all sizes and industries. Search Engine Optimization (SEO) plays a vital role in improving your website's visibility and driving organic traffic from search engines. At Molto SEO, a leading SEO agency in the UK, we understand the importance of utilizing SEO to enhance your online presence and achieve business success. Let's explore ",
                                                        answerThePublic[10].title,
                                                        ", an essential tool for your digital marketing strategy."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Increased Website Visibility: With our transparent and competitive SEO pricing UK, Molto SEO ensures that your website ranks higher in search engine results pages (SERPs). By optimizing your website's content, structure, and technical aspects, we enable search engines to understand and index your site effectively. This increased visibility enhances your chances of reaching potential customers and standing out from the competition."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Targeted Organic Traffic: Our tailored SEO strategies focus on attracting targeted and relevant organic traffic to your website. Through extensive keyword research and optimization techniques, we ensure that your website appears in search results for keywords that matter most to your business. By driving quality traffic to your website, we increase the likelihood of conversions, leads, and sales."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Improved User Experience: SEO goes hand in hand with providing a positive user experience. At Molto SEO, we analyze your website's performance, user interface, and navigation to optimize user experience. By improving loading speed, enhancing site structure, and delivering valuable content, we ensure that visitors have a seamless browsing experience. A user-friendly website encourages engagement, reduces bounce rates, and increases the chances of conversions."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Long-Term Business Growth: Our experienced team at Molto SEO understands the importance of long-term business growth. We implement SEO strategies that focus on sustainable results. By continuously optimizing your website, creating high-quality content, and building authoritative backlinks, we establish a strong online presence that attracts organic traffic over time. This consistent growth leads to increased brand recognition, customer loyalty, and business success."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Cost-Effectiveness: Molto SEO offers affordable SEO packages that provide a high return on investment. Unlike paid advertising that incurs ongoing expenses, SEO brings organic traffic without additional costs. By optimizing your website and targeting relevant keywords, we drive targeted traffic to your site, reducing your reliance on paid channels. Our cost-effective SEO services ensure that you maximize your digital marketing budget and achieve long-term results."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Competitive Advantage: In a sea of competitors, SEO gives you a significant advantage. By ranking higher in search results and offering a superior user experience, you differentiate your business from others in your industry. At Molto SEO, we help you outperform your competitors by implementing effective SEO strategies tailored to your unique business goals and target audience."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Molto SEO is dedicated to help you understand what SEO is, ",
                                                        answerThePublic[10].title,
                                                        ", and what results you can expect from us. Utilizing SEO is crucial for enhancing your online presence and achieving business success. With Molto SEO's expertise in technical SEO, web analytics, and Google Ads, we provide a comprehensive approach to improve your website's visibility, drive targeted traffic, and maximize your online potential. Whether you're a small business or a large enterprise, incorporating SEO into your digital marketing strategy is essential for staying competitive, attracting customers, and achieving your business goals."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: answerThePublic[5].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Pricing SEO services can vary depending on several factors, such as the scope of work, the competitiveness of the industry, and the desired results. When determining",
                                                        " ",
                                                        answerThePublic[5].title,
                                                        ", it's important to consider the value that SEO brings to a business. SEO is not just about ranking higher in search engine results; it's about driving targeted organic traffic, increasing visibility, and ultimately generating conversions and revenue."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Typically, SEO pricing is based on the level of service required and the amount of time and effort needed to achieve the desired goals. Some SEO agencies offer fixed packages with predefined services, while others provide custom pricing based on a thorough analysis of the client's website and business needs. A comprehensive SEO strategy may include keyword research, on-page optimization, technical SEO audits, link building, content creation, and ongoing monitoring and reporting."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "When pricing SEO services, it's crucial to consider the long-term benefits that SEO can bring to a business. Investing in SEO can lead to sustainable growth, increased brand visibility, and a competitive edge in the online market. By attracting targeted organic traffic and optimizing the user experience, SEO has the potential to generate a high return on investment (ROI) and deliver lasting results."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: answerThePublic[9].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "For small businesses, SEO is a powerful tool that can level the playing field and help them compete with larger, more established brands. In today's digital landscape, where online searches play a crucial role in consumer decision-making, having a strong online presence is essential for small businesses to succeed."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "SEO provides small businesses with an opportunity to increase their visibility and reach a wider audience. By optimizing their website and content for relevant keywords and phrases, small businesses can improve their organic rankings in search engine results. This increased visibility allows them to attract more targeted traffic and potential customers who are actively searching for their products or services."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Moreover, SEO allows small businesses to establish credibility and build trust with their target audience. By consistently providing valuable and relevant content, optimizing their website for a seamless user experience, and earning high-quality backlinks from reputable sources, small businesses can position themselves as authorities in their industry. This helps to build trust among consumers, which can result in increased brand loyalty and customer retention."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Furthermore, SEO offers a cost-effective marketing strategy for small businesses. Compared to traditional advertising methods, SEO can provide long-term results without the need for significant ongoing investment. By investing in SEO, small businesses can drive organic traffic to their website, generate leads, and increase conversions, all while optimizing their marketing budget."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "In summary, SEO is crucial for small businesses because it allows them to increase their online visibility, attract targeted traffic, build credibility, and achieve sustainable growth. By implementing effective SEO strategies, small businesses can compete in the digital landscape and reach their target audience, ultimately driving success and achieving their business goals."
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFooterCombo/* default */.Z, {
                        location: "london"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var seo_pricing_uk = (croPage);


/***/ }),

/***/ 77632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86523);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22546);







// ==================================================================
var Carousel = function(props) {
    var children = props.children, slideClassName = props.slideClassName, _spaceBetween = props.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 30 : _spaceBetween, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 3 : _slidesPerView, _pagination = props.pagination, pagination = _pagination === void 0 ? true : _pagination, _navigation = props.navigation, navigation = _navigation === void 0 ? true : _navigation, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "children",
        "slideClassName",
        "spaceBetween",
        "slidesPerView",
        "pagination",
        "navigation"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), prevEl = ref[0], setPrevEl = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nextEl = ref1[0], setNextEl = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        spaceBetween: spaceBetween,
        slidesPerView: slidesPerView,
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
        ],
        navigation: navigation ? {
            prevEl: prevEl,
            nextEl: nextEl
        } : false,
        pagination: pagination ? {
            clickable: true
        } : false
    }, others), {
        children: [
            children.map(function(slide, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                    className: slideClassName,
                    children: slide
                }, i);
            }),
            navigation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "swiper-navigation",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setPrevEl(node);
                        },
                        className: "swiper-button swiper-button-prev swiper-button-disabled"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setNextEl(node);
                        },
                        className: "swiper-button swiper-button-next"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);


/***/ }),

/***/ 79266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 454).then(__webpack_require__.bind(__webpack_require__, 454));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(454)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Drop Us a Line",
                    body: "Reach out to us from our contact form and we will get back to you shortly.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 42744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);





// ====================================================
var FigureImage = function(props) {
    var className = props.className, src = props.src, width = props.width, height = props.height, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "className",
        "src",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className
    }, others), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            width: width,
            height: height,
            src: src,
            alt: "demo",
            quality: "100"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FigureImage);


/***/ }),

/***/ 79588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
// useLogVisitor.js


var useLogVisitor = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var visitor = Array.isArray(router.query.visitor) ? router.query.visitor[0] : router.query.visitor;
        if (visitor) {
            fetch("/.netlify/functions/logVisitor?visitor=".concat(encodeURIComponent(visitor))).then(function(response) {
                return response.json();
            }).then(function(data) {
                console.log("Visitor logged:", data.message);
            }).catch(function(error) {
                console.error("Error logging visitor:", error);
            });
        }
    }, [
        router.query.visitor
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLogVisitor);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,4525,61,4870,4556,9447,9774,2888,179], function() { return __webpack_exec__(38819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);